import './index.scss';
import React, { FC, useState } from 'react';
import { Flex, Grid, List, Progress, Typography } from 'antd';
import { SvgIcon } from '@/components/icon';
import { ProfileStep } from '@/slice/user';
import { useNavigate } from 'react-router';
import { EditOutlined } from '@ant-design/icons';
const { Text } = Typography;

interface Props {
  align: 'top' | 'bottom';
  offset?: string;
  steps: ProfileStep[];
}

export const ProfileProgressBar: FC<Props> = (props) => {
  const { align = 'bottom', steps, offset } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState<number | null>(null);
  const completedSteps = steps.filter((step) => step.completed).length;
  const totalSteps = steps.length;
  const progressPercent = Math.round((completedSteps / totalSteps) * 100);
  const { lg } = Grid.useBreakpoint();
  const navigate = useNavigate();
  const isTop = align === 'top';

  const handleNavigate = (item: ProfileStep) => {
    navigate(item.link);
    setIsOpen(false);
  };

  if (completedSteps === totalSteps) return null;

  return (
    <div
      className={'profile-progress-bar-container'}
      style={{
        [isTop ? 'top' : 'bottom']: `${offset ?? lg ? '30%' : '0%'}`,
      }}
    >
      <Flex
        justify={'space-between'}
        align={'center'}
        className={'progress-btn'}
        onClick={() => setIsOpen(!isOpen)}
        gap={16}
      >
        <Text className={'progress-btn-title'}>Profile Completeness</Text>
        <Flex align={'center'} gap={8}>
          <Progress
            percent={progressPercent}
            showInfo={false}
            strokeColor="#2f54eb"
            size="small"
            style={{ width: '69px' }}
          />
          <Text
            className={'progress'}
          >{`${completedSteps}/${totalSteps}`}</Text>
          <Flex
            align={'center'}
            justify={'center'}
            className={`chevron-icon-container ${
              isOpen ? (!isTop ? '' : 'rotate180') : !isTop ? 'rotate180' : ''
            }`}
          >
            <SvgIcon type={'chevronDown'} />
          </Flex>
        </Flex>
      </Flex>
      {isOpen && (
        <List
          className={'steps-list'}
          itemLayout="horizontal"
          dataSource={steps}
          renderItem={(item, index) => (
            <List.Item
              className={'step-item'}
              onClick={() => handleNavigate(item)}
              style={{
                cursor: 'pointer',
              }}
              onMouseEnter={() => setHoveredItem(index)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <List.Item.Meta
                avatar={
                  item.completed ? (
                    <Flex
                      align={'center'}
                      justify={'center'}
                      className={'step-number-container completed'}
                    >
                      <SvgIcon type={'checkCircleFilled'} />
                    </Flex>
                  ) : (
                    <Flex
                      align={'center'}
                      justify={'center'}
                      className={'step-number-container'}
                    >
                      {hoveredItem === index ? (
                        <EditOutlined />
                      ) : (
                        <span>{`0${index + 1}`}</span>
                      )}
                    </Flex>
                  )
                }
                title={
                  <Typography.Text
                    className={'step-title'}
                    style={{
                      color:
                        hoveredItem === index && !item.completed
                          ? '#1890ff'
                          : undefined,
                    }}
                  >
                    {item.title}
                  </Typography.Text>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
};
